var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-page-header',{attrs:{"icon":"fa fa-dashboard","title":"Painel","breadcrumbs":[
				{ href: '', title: 'Painel' }
			]}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('app-jumbotron',{attrs:{"name":_vm.userName}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }